import {
  setLocalItem,
  getLocalItem,
  timeFormat,
  getItem
} from '@/utils/comUtils'
import { SKU_TIP } from '@/utils/constUtils'
export default {
  namespaced: true,
  state: {
    // 弹窗
    promptTitle: '',
    promptContent: '',

    alreadyExpirePrompt: false, // 到期通知
    alreadyExpireSkuList: [], // 已到期的套餐列表
    toBeExpirePrompt: false, // 即将到期通知
    toBeExpireModuleList: [], // 即将到期的模块列表
    toBeExpireSkuList: [], // 即将到期的套餐列表

    deviceAlreadyExpirePrompt: false, // 亲情通话设备已到期通知
    familyCallDeviceToBeExpire: [], // 即将到期的亲情通话设备
    deviceToBeExpirePrompt: false, // 亲情通话设备即将到期通知
    familyCallDeviceAlreadyExpire: [], // 已到期的亲情通话设备

    // 顶部提示
    topPromptStatus: {
      showPrompt: false, // 提示框状态
      time: null
    },
    module: null,
    skuTipContent: '',
    isHome: false
  },
  mutations: {
    // 初始化套餐到期相关数据
    initExpireSkuData(state, res) {
      Object.assign(state, res)
    },
    // 设置弹窗内容
    setExpireSkuDialog(state) {
      function initPromptContent(
        { status = '', text1 = '', text2 = '' },
        expireSkuList
      ) {
        let concatText = ''
        let tipList = [] // 套餐对应的提示语列表
        let content = '' // 弹窗内容

        // 获取套餐名并去重
        const skuList = [...new Set(expireSkuList.map(item => item.skuName))]

        // 根据套餐选择文本
        concatText = skuList.some(item =>
          [
            '精选版',
            '放学管理功能',
            '德育功能',
            '电子班牌功能',
            '宿舍管理功能',
            '校园防疫功能'
          ].includes(item)
        )
          ? text2
          : text1
        // 拼接文本
        skuList.forEach((item, index, arr) => {
          content +=
            index + 1 !== arr.length ? `「${item}」、` : `「${item}」${status}`
        })

        content += concatText

        skuList.forEach(item => {
          if (SKU_TIP[item]) {
            tipList = [...tipList, ...SKU_TIP[item]]
          }
        })
        tipList = [...new Set(tipList)]
        tipList.forEach((item, index) => {
          content += `${index + 1}、${item}`
        })
        content += '请及时联系客服咨询。'
        state.promptContent = content
      }
      // 初始化弹窗内容
      if (state.alreadyExpirePrompt) {
        state.promptTitle = '套餐到期提醒'
        const contenText = {
          status: '已到期。<br>',
          text1: '套餐内功能将不可使用，',
          text2: '以下功能将不能使用：<br>'
        }
        initPromptContent(contenText, state.alreadyExpireSkuList)
      } else if (state.deviceAlreadyExpirePrompt) {
        state.promptTitle = '套餐到期提醒'
        state.promptContent = `您的${state.familyCallDeviceAlreadyExpire.length}台亲情通话设备的套餐已到期，学生将无法使用设备进行通话，请及时联系客服续费<br/>`
      } else if (state.toBeExpirePrompt) {
        state.promptTitle = '套餐即将到期'
        // 获取套餐时间 多套餐取最早时间
        if (state.toBeExpireSkuList.length) {
          let time = state.toBeExpireSkuList.map(item => {
            return item.expireTime
          })
          time = Math.min.apply(null, time)
          time = timeFormat(new Date(time), 'YYYY.MM.DD')
          const contenText = {
            status: '即将到期。<br>',
            text1: `到期时间：${time}，到期后套餐内功能将不可使用，`,
            text2: `到期时间：${time}，到期后以下功能将不能使用：<br>`
          }
          initPromptContent(contenText, state.toBeExpireSkuList)
        } else if (state.familyCallDeviceToBeExpire.length) {
          state.promptTitle = '套餐即将到期'
          state.promptContent = `您的${state.familyCallDeviceToBeExpire.length}台亲情通话设备的套餐即将到期，学生将无法使用设备进行通话，请及时联系客服续费<br/>`
        }
      } else if (state.deviceToBeExpirePrompt) {
        state.promptTitle = '套餐即将到期'
        state.promptContent = `您的${state.familyCallDeviceToBeExpire.length}台亲情通话设备的套餐即将到期，学生将无法使用设备进行通话，请及时联系客服续费<br/>`
      }
    },

    // 初始化顶部提示
    initExpireSkuPrompt(state, meta = { modular: -1, info: '首页——非家长' }) {
      // 没有即将到期模块 中止
      if (
        state.toBeExpireModuleList.length === 0 &&
        (state.familyCallDeviceToBeExpire || []).length === 0
      ) {
        return
      }
      state.module = 'toBeExpireModule_' + meta.modular
      // 判断首页
      state.isHome =
        (meta.modular === -1 && meta.info === '首页——非家长') ||
        (['8'].includes(getItem('platformSource')) &&
          meta.info === '亲情通话——首页') ||
        (['12'].includes(getItem('platformSource')) && meta.name === 'PageMeal')
      // 模块首页
      let isModuleHome = [
        'PageHome',
        'PageGuardianIndex',
        'PageMoralEvaluationMultiRoleIndex',
        'PageClasscard',
        'PageClassrankAll',
        'PageFamilyCall',
        'PageMeal'
      ].includes(meta.name)
      // 初始化即将到期模块列表

      // 当前模块是否到期
      const expireModule = state.toBeExpireModuleList.find(item => {
        return item.moduleId === meta.modular
      })
      // 模块未到期，且不是首页 隐藏bar
      if (
        !expireModule &&
        !state.isHome &&
        !state.familyCallDeviceToBeExpire.length
      ) {
        return (state.topPromptStatus.showPrompt = false)
      }
      // 显示内容
      if (state.isHome && !['8', '12'].includes(getItem('platformSource'))) {
        state.skuTipContent = '您有套餐即将到期，请及时联系客服续费。点击详情>>'
      } else if (state.familyCallDeviceToBeExpire.length) {
        state.skuTipContent = `当前有 ${state.familyCallDeviceToBeExpire.length} 台亲情通话设备的套餐即将到期。点击查看>>`
      } else {
        state.skuTipContent = `该应用使用权限将于 ${timeFormat(
          new Date(expireModule.expireTime - 0),
          'YYYY.MM.DD'
        )} 到期，请及时联系客服。点击咨询>>`
      }
      // 显示规则 @todo: 亲情通话设备如果存在即将到期，需要展示置顶通知
      if (getLocalItem(state.module)) {
        state.topPromptStatus = getLocalItem(state.module)
        if (state.topPromptStatus.time !== timeFormat(new Date(), 'YYYYMMDD')) {
          state.topPromptStatus.showPrompt = true // 重置为显示
          state.topPromptStatus.time = null
          setLocalItem(state.module, state.topPromptStatus)
        }
      } else {
        state.topPromptStatus.showPrompt =
          ((!!expireModule ||
            (state.familyCallDeviceToBeExpire.length &&
              meta.info === '亲情通话——首页')) &&
            isModuleHome) ||
          state.isHome
      }
    },
    // 关闭顶部提示 本地存储
    setExpireSkuLocal(state, status) {
      state.topPromptStatus = {
        ...state.topPromptStatus,
        ...status
      }
      setLocalItem(state.module, state.topPromptStatus)
    },
    // 控制弹窗显示
    showExpireSkuDialog(state, payload) {
      if (payload) {
        state.alreadyExpirePrompt = false
      }
      state.toBeExpirePrompt = payload
    }
  }
}
